'use client'

import { prepareForSlot } from '@mui/base'
import NextLink from 'next/link'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../../../global-config'
import { urlResolverGetContactUs } from '../../../../url-handling'

/**
 * Follow the example https://v6.mui.com/base-ui/react-button/#using-with-links.
 */
const LinkSlot = prepareForSlot(NextLink)

export const SearchPageNoResultContactForm: FC = () => {
  const config = useGlobalConfigContext()

  return (
    <div className="flex flex-col items-start gap-6 rounded-2xl bg-light-primary-medium p-6">
      <div className="text-m">
        <FormattedMessage id="searchResults.empty.contact.prompt_ho" />
      </div>
      <Button<typeof NextLink>
        className="w-full"
        href={urlResolverGetContactUs(config, {
          queryParams: { target: 'search-page' },
        })}
        size="large"
        slots={{ root: LinkSlot }}
        variant="outlined"
      >
        <FormattedMessage id="general.label.contactForm" />
      </Button>
    </div>
  )
}
